import React from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  title: string;
  className?: string;
  classNameText?: string;
};

function Checkbox({ checked, onChange, title, className, classNameText }: Props) {
  return (
    <label
      className={twMerge(
        "flex gap-[10px] items-center cursor-pointer",
        className,
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="peer sr-only"
      />
      <div
        className="relative border border-[#DFE4EA] bg-white rounded-full w-5 h-5
        peer-checked:bg-transparent peer-checked:border-darkblue
        peer-checked:after:content-['']
        peer-checked:after:absolute
        peer-checked:after:inset-0 peer-checked:after:m-auto peer-checked:after:bg-darkblue
        peer-checked:after:rounded-full peer-checked:after:w-2.5 peer-checked:after:h-2.5"
      />
      <span className={twMerge(
        "text-base text-black",
        classNameText
      )}>{title}</span>
    </label>
  );
}

export default Checkbox;
